/** Client-safe public configuration only — never expose secrets here. */
export function getPublicEnv(): { apiBaseUrl: string } {
  const raw =
    process.env.NEXT_PUBLIC_API_BASE_URL?.trim() ||
    /* Local development default aligned with backend-api Docker Compose port (mapped to host 3001) */
    'http://localhost:3001';
  return { apiBaseUrl: raw.replace(/\/+$/, '') };
}
